import React, { useState } from 'react';
import {
  ChooseProductContainer,
  ProductButtons,
  ProductDescription,
  ProductTitle,
  Header,
  Subheader
} from './styled';

import ProductButton from './components/ProductButton';
import Background from './components/ChooseProductBackground';

import { PRODUCTS } from './consts';

const ChooseProduct = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const renderProductButton = (product) => (
    <ProductButton
      key={product.name}
      productLink={product.link}
      onMouseEnter={() => setSelectedProduct(product)}
      onMouseLeave={() => setSelectedProduct(null)}
      icon={product.icon}
      color={product.color}
      hoverChildren={<ProductDescription>{product.description}</ProductDescription>}
    >
      <ProductTitle>{product.title}</ProductTitle>
    </ProductButton>
  );

  return (
    <ChooseProductContainer bg={selectedProduct?.bg || 'black'}>
      <Header>Welcome!</Header>
      <Subheader>Please choose the product you want to sign up for.</Subheader>
      <ProductButtons>
        {Object.values(PRODUCTS).map((product) => renderProductButton(product))}
      </ProductButtons>
      <Background selectedProduct={selectedProduct} />
    </ChooseProductContainer>
  );
};

export default ChooseProduct;
